import type { Trips_GetAdditionalPayment_GetAdditionalPaymentQueryResponse_Success } from "../../swagger-types/v1/index.js";

type AdditionalPaymentGetResponse = Trips_GetAdditionalPayment_GetAdditionalPaymentQueryResponse_Success;

const baseResponse: AdditionalPaymentGetResponse = {
  amount: {
    amount: 11.0,
    currencyCode: "USD",
  },
  status: "Draft",
  reason: "AdditionalBed",
  hotelName: "Andaz 5th Avenue",
  comments: "asdf",
  paymentProvider: {
    isPaymentInDifferentCurrency: false,
    isTaxIdRequired: false,
    providerCode: "Stripe",
    providerMetadata:
      '{"PublicKey":"pk_test_51PxCceBFjgT4ftd9kR8JsnMsskfxUBiTSGFXlj9QMJXpBEigrJGmdUnm7hosqkzWzlps4mKvxtZ32EBhqP98MuM000O9rIhhAX","CardTypeMapping":{"amex":"AmericanExpress","visa":"Visa","mastercard":"MasterCard","diners":"Diners","jcb":"JCB","discover":"Discover","unionpay":"UnionPay","unknown":"Unknown"}}',
  },
  tripDetails: {
    id: 40445,
    guestDetails: {
      firstName: "Guest",
      lastName: "LastName",
    },
    roomName: "Standard Room",
    boardCode: "FullBoard",
    checkIn: "2025-12-09",
    checkOut: "2025-12-10",
    numberOfNights: 1,
    occupancies: [
      {
        adults: 2,
        children: [],
      },
    ],
  },
};

export const createAdditionalPaymentResponse200 = ({
  status,
  currencyCode = "USD",
  isTaxIdRequired = false,
  amount = status === "Completed" ? 12 : baseResponse.amount.amount,
}: {
  status: AdditionalPaymentGetResponse["status"];
  currencyCode?: AdditionalPaymentGetResponse["amount"]["currencyCode"];
  isTaxIdRequired?: AdditionalPaymentGetResponse["paymentProvider"]["isTaxIdRequired"];
  amount?: AdditionalPaymentGetResponse["amount"]["amount"];
}): AdditionalPaymentGetResponse => ({
  ...baseResponse,
  status,
  amount: {
    ...baseResponse.amount,
    currencyCode,
    amount,
  },
  paymentProvider: {
    ...baseResponse.paymentProvider,
    isTaxIdRequired,
  },
});

export const getDraftAdditionalPaymentResponse200 = createAdditionalPaymentResponse200({ status: "Draft" });
export const getCompletedAdditionalPaymentResponse200 = createAdditionalPaymentResponse200({ status: "Completed" });
export const getFailedAdditionalPaymentResponse200 = createAdditionalPaymentResponse200({ status: "Failed" });
export const getInProcessAdditionalPaymentResponse200 = createAdditionalPaymentResponse200({ status: "InProcess" });
export const getDraftAdditionalPaymentResponse200BRL = createAdditionalPaymentResponse200({
  status: "Draft",
  currencyCode: "BRL",
  isTaxIdRequired: true,
});
export const getFailedAdditionalPaymentResponse200BRL = createAdditionalPaymentResponse200({
  status: "Failed",
  currencyCode: "BRL",
  isTaxIdRequired: true,
});
